var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import FaqService from "../services/FaqService";
import { Accordion } from "react-bootstrap";
import Notification from "../../App/components/Notification";
import Title from "../components/Title";
function Faq() {
    var _a = useState(), faqData = _a[0], setFaqData = _a[1];
    useEffect(function () {
        getFaq();
    }, []);
    function getFaq() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Notification().Loading.dots("Buscando Dados");
                FaqService.getFaqsInternal().then(function (res) {
                    setFaqData(res.data);
                    Notification().Loading.remove();
                }, function (error) {
                    console.log("error", error);
                });
                return [2 /*return*/];
            });
        });
    }
    function parseTextWithLinks(text) {
        var urlRegex = /(https?:\/\/[^\s<>"{}|\\^`\[\]]+)/g;
        var parts = text.split(urlRegex);
        return parts.map(function (part, index) {
            if (part.startsWith("http://") || part.startsWith("https://")) {
                return (_jsx("a", __assign({ href: part, target: "_blank", rel: "noopener noreferrer", style: {
                        color: "#0066cc",
                        textDecoration: "underline",
                        wordBreak: "break-word",
                    } }, { children: part }), index));
            }
            return _jsx("span", { children: part }, index);
        });
    }
    return (_jsx("div", __assign({ className: "content-internal-padding" }, { children: _jsxs("div", __assign({ className: "container-fluid" }, { children: [_jsx(Title, { text: "FAQ" }), faqData !== undefined ? (Object.keys(faqData.faq).map(function (item, index) {
                    return (_jsxs(_Fragment, { children: [_jsx("h4", __assign({ style: {
                                    marginBottom: "0.5rem",
                                    marginTop: "1.5rem",
                                    marginLeft: "0.4rem",
                                } }, { children: item })), _jsx(Accordion, __assign({ defaultActiveKey: "false" }, { children: faqData.faq[item].map(function (itemFaq, indexFaq) { return (_jsxs(Accordion.Item, __assign({ eventKey: indexFaq, style: { marginBottom: "15px" } }, { children: [_jsx(Accordion.Header, { children: itemFaq.question }), _jsx(Accordion.Body, { children: _jsx("p", __assign({ style: {
                                                    color: "#767676",
                                                    fontSize: "0.95rem",
                                                    marginTop: "0.7rem",
                                                    whiteSpace: "pre-line",
                                                } }, { children: parseTextWithLinks(itemFaq.response) })) })] }))); }) }))] }));
                })) : (_jsx("p", { children: "Nenhum dado encontrado!" }))] })) })));
}
export default Faq;
